import React from "react";
import { Bar } from "react-chartjs-2";
import POWER_RANGE from "../../../../resources/images/power-range.png";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Card, CardContent, Typography } from "@mui/material";

// Register necessary components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels
);

const PowerRange = () => {
  const yLabels = [
    "ST440",
    "S440",
    "SJV437",
    "SJV436",
    "TSJ436",
    "SJ436",
    "S433",
    "SJV326",
    "SJV325",
    "S325",
    "S324",
    "SSS4219CR",
    "SSS4219",
    "S217  ",
  ];

  // X-axis values corresponding to each label
  const xValues = [
    [75, 100.5],
    [75, 80.5],
    [75, 136],
    [65, 75],
    [60, 74],
    [62, 63],
    [41.5, 59],
    [45, 60],
    [38.5, 58],
    [49.5, 52],
    [40, 75],
    [30, 50],
    [31.5, 47],
    [36, 37],
    [30, 50],
    [30, 50],
    [20, 24],
    [16, 25],
  ];

  const data = {
    labels: yLabels, // Labels for the Y-axis
    datasets: [
      {
        label: "Range",
        data: xValues, // Data for each label
        backgroundColor: "rgba(75, 192, 192, 0.86)", // Bar colors
        borderColor: "rgb(10, 72, 72)", // Border color
        borderWidth: 1,
        borderSkipped: false,
      },
    ],
  };
  const options = {
    indexAxis: "y", // Makes the chart horizontal
    responsive: true,
    plugins: {
      legend: {
        position: "top", // Legend position
      },
      datalabels: {
        display: false,
      },
    },

    scales: {
      x: {
        beginAtZero: true,
        title: {
          display: false,
        },
      },
      y: {
        title: {
          display: false,
        },
        grid: {
          display: false,
        },
      },
    },
  };

  return (
    <Card sx={{ width: "90%", margin: "auto", mt: 2, mb: 2 }}>
      <CardContent>
        <Typography variant="h4" sx={{ textAlign: "center" }}>
          Power Range
        </Typography>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <img src={POWER_RANGE} alt="Power Range" />
        </div>

        {/* <div
          style={{ height: "80vh", display: "flex", justifyContent: "center" }}
        >
          <Bar data={data} options={options} />
        </div> */}
      </CardContent>
    </Card>
  );
};

export default PowerRange;
